import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCalculator } from '../../context/CalculatorContext';
import styles from './Calculator.module.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Ave from '../../assets/Ave.svg';
import Title from '../../assets/Title.svg';
import TextDecorador from '../../assets/globo con texto.png';

function Calculator() {
  const navigate = useNavigate();
  const { 
    combustible, 
    setCombustible, 
    consumo, 
    setConsumo, 
    combustibles,
    calcular 
  } = useCalculator();

  const handleBack = () => {
    navigate('/contact');
  };

  const handleNext = (e) => {
    e.preventDefault();
    
    // Validación básica
    if (!combustible || !consumo) {
      alert('Por favor complete todos los campos');
      return;
    }
    
    // Realizar cálculo
    const resultado = calcular();
    
    if (!resultado.success) {
      alert(resultado.error);
      return;
    }
    
    // Solo navegar si el cálculo fue exitoso
    navigate('/results');
  };

  // Obtener unidad del combustible seleccionado
  const combustibleSeleccionado = combustibles.find(c => c.id === combustible);
  const unidadMedida = combustibleSeleccionado ? combustibleSeleccionado.unidad : 'unidades';

  return (
    <div className={styles.calculator}>
      <Header />
      <div className={styles.content}>
        <div className={styles.headerImages}>
          <img src={Title} alt="Calculadora Ambiental" className={styles.titleImage} />
          <img src={TextDecorador} alt="Decorador" className={styles.decoratorImage} />
        </div>
        <div className={styles.formContainer}>
          <img src={Ave} alt="Ave" className={styles.aveIcon} />
          <h2 className={styles.title}>¿Con cuál energético deseas comparar?</h2>
          <form className={styles.calculatorForm} onSubmit={handleNext}>
            <div className={styles.formGroup}>
              <label htmlFor="combustible">Seleccione su combustible actual</label>
              <div className={styles.inputWrapper}>
                <svg className={styles.icon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77z"/>
                </svg>
                <select
                  id="combustible"
                  value={combustible}
                  onChange={(e) => setCombustible(e.target.value)}
                  required
                  className={styles.select}
                >
                  <option value="">Seleccione una opción</option>
                  {combustibles.map(c => (
                    <option key={c.id} value={c.id}>{c.nombre}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="consumo">
                Consumo promedio mensual ({unidadMedida})
              </label>
              <div className={styles.inputWrapper}>
                <svg className={styles.icon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 14c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"/>
                </svg>
                <input
                  type="number"
                  id="consumo"
                  value={consumo}
                  onChange={(e) => setConsumo(e.target.value)}
                  required
                  min="0"
                  step="0.01"
                />
              </div>
              <span className={styles.placeholder}>
                Ingrese su consumo mensual promedio de {combustibleSeleccionado ? combustibleSeleccionado.nombre.toLowerCase() : 'combustible'} en {unidadMedida}
              </span>
            </div>
          </form>
          <div className={styles.buttons}>
            <button type="button" className={styles.backButton} onClick={handleBack}>
              Atrás
            </button>
            <button type="button" className={styles.nextButton} onClick={handleNext}>
              Calcular
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Calculator;